'use strict';

import {contractModel} from "../../models/contractmodel.js";
import {fieldModel} from "../../models/fieldmodel.js";
import {communicationSubjectModel} from "../../models/communicationsubjectmodel.js";
import {CommunicationSubjectEditorCtrl} from '../communication/communicationsubjecteditorctrl.js';

export class ContractInfoCtrl
{
	$scope;
	$filter;
	jsDataService;
	$mdDialog;
	item = {};
	fieldCfg = {};
	signRefuseUrl;
	signReturnUrl;
	signCodeUrl;
	
	constructor($scope, $filter, jsDataService, $mdDialog){
		'ngInject';
		this.$scope = $scope;
		this.$filter = $filter;
		this.jsDataService = jsDataService;
		this.$mdDialog = $mdDialog;
		this.classif = this.jsDataService.get('cfgClassif', {});
		this.item = new contractModel(jsDataService.get('applicationBase', {}), $filter, jsDataService);
		this.makeFieldCfg(this.item.fields);
		this.signRefuseUrl = this.jsDataService.get('signRefuseUrl', '');
		this.signReturnUrl = this.jsDataService.get('signReturnUrl', '');
		this.signCodeUrl = this.jsDataService.get('signCodeUrl', '');
	}
	
	makeFieldCfg(fields){
		if(typeof(fields) !== 'undefined'){
			for(let fld of Object.values(fields)){
				this.fieldCfg[fld.name] = new fieldModel(fld);
			}
		}
	}
	
	isField(name){
		return (typeof(this.fieldCfg[name]) !== 'undefined');
	}
	
	getFieldTitle(name){
		if(this.isField(name)){
			return this.fieldCfg[name].title;
		}
		return '';
	}
	
//	applicationSubmit(ev){
//		if(this.item.status < 1){
//			this.$mdDialog.show({
//				controller: ["$scope", "$mdDialog", "item", this.submitDialogCtrl],
//				templateUrl: 'application/application_submit.html',
//				parent: angular.element(document.body),
//				targetEvent: ev,
//				clickOutsideToClose:false,
//				fullscreen: true,
//				locals: {
//					item: this.item
//				}
//			}).then((results) => {
//				console.log('dialog close', results);
//			}, () => {});
//		}
//	}
//	
//	applicationRevoke(ev){
//		if(this.item.status > 0 && typeof(this.item.revoke_url) !== 'undefined' && this.item.revoke_url !== ''){
//			const confirmTexts = this.jsDataService.get('revokeConfirmTexts');
//			const confirm = this.$mdDialog.confirm()
//				.title(confirmTexts.title)
//				.htmlContent(confirmTexts.content)
//				.ariaLabel(confirmTexts.title)
//				.targetEvent(ev)
//				.ok(confirmTexts.ok)
//				.cancel(confirmTexts.cancel);
//			this.$mdDialog.show(confirm).then(() => {
//				this.$scope.basicHttpConfigProcess({
//					url: this.item.revoke_url,
//					method: 'GET',
//					responseType: 'json',
//				}).then((results) => {});
//			}, () => {});
//		}
//	}
//
//	applicationRemove(ev){
//		if(this.item.status == 0 && typeof(this.item.remove_url) !== 'undefined' && this.item.remove_url !== ''){
//			const confirmTexts = this.jsDataService.get('removeConfirmTexts');
////			const applicationPageUrl = this.jsDataService.get('applicationPageUrl');
//			const confirm = this.$mdDialog.confirm()
//				.title(confirmTexts.title)
//				.htmlContent(confirmTexts.content)
//				.ariaLabel(confirmTexts.title)
//				.targetEvent(ev)
//				.ok(confirmTexts.ok)
//				.cancel(confirmTexts.cancel);
//			this.$mdDialog.show(confirm).then(() => {
//				this.$scope.basicHttpConfigProcess({
//					url: this.item.remove_url,
//					method: 'GET',
//					responseType: 'json'
//				}).then((results) => {
//					if(results.data.success){
////						window.location.href = applicationPageUrl;
//					}
//				});
//			}, () => {});
//		}
//	}
	
	contractStatus(ev){
		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", "jsDataService", "item", this.statusDialogCtrl],
			templateUrl: 'contracts/contract_status.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose:false,
			fullscreen: true,
			locals: {
				item: this.item
			}
		}).then((results) => {
			this.$scope.$root.basicHttpConfigProcess({
				url: this.item.status_url,
				method: 'POST',
				responseType: 'json',
				data: results
			});
		}, () => {});
	}
	
	statusDialogCtrl($scope, $mdDialog, jsDataService, item){
		$scope.classif = jsDataService.get('cfgClassif', []);
		$scope.item = angular.copy(item);
		$scope.item.message = '';
		
		$scope.close = function() {
			$mdDialog.cancel();
		};
		
		$scope.save = function() {
			$mdDialog.hide($scope.item);
		};
	}
	
	/////
	go2Url(urlString){
		this.$scope.goUrl(urlString);
	}
	
	openSubjectDialog(ev){
		const subject = new communicationSubjectModel({
			message: this.$filter('tr')('default_send_for_sign_message').replace(/<\/?[^>]+(>|$)/g, ""),
			submission_date: '',
			attachment: [],
			object_number: this.objectNumber,
		});
		
		
		this.$mdDialog.show({
			controller: ['$scope', '$mdDialog', '$filter', 'jsDataService', 'subject', this.SendForSignEditorCtrl],
			controllerAs: 'ctrl',
			templateUrl: 'contracts/send_for_sign_editor.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: false,
			fullscreen: true,
			locals: {
				subject: subject,
			}
		}).then((results) => {
			this.publishSubject(results);
		}, (results) => {
			console.log(results);
		});
	}

	SendForSignEditorCtrl($scope, $mdDialog, $filter, jsDataService, subject){
		$scope.subject = angular.copy(subject);
//		console.log($scope.subject)
		$scope.subjectForm;
		$scope.uploadUrl = jsDataService.get('cfgUploadUrl');
		$scope.close = function() {
			$mdDialog.cancel();
		};

		$scope.save = function() {
			if(!this.isValid()) {
				return;
			}
			$mdDialog.hide($scope.getSaveData());
		};

		$scope.fileAdded = function ($file) {
			const file = {
				id: '0',
				file_id: '0',
				name: $file.name,
				isFlow: true,
				flowFile: $file,
			};

			$scope.subject.attachment.push(file);
			return true;
		};

		$scope.fileSubmitted = function() {
			$scope.subject.flow.upload();
		};

		$scope.fileUploaded = function ($file, $message) {
			const file = $scope.subject.attachment.find(f => f.flowFile?.uniqueIdentifier === $file.uniqueIdentifier);

			if(!file) {
				return;
			}

			try {
				const response = JSON.parse($message);
				file.file_id = response.fileId;
				$scope.subjectForm['attachment'].$setViewValue(Date.now());
			} catch(err) {

			}
		};

		$scope.removeFile = function (file) {
			$scope.subject.attachment = $scope.subject.attachment.filter(f => f !== file);
			$scope.subjectForm['attachment'].$setViewValue(Date.now());
		};

		$scope.isValid = function (){
			return !$scope.subject.flow.isUploading();
		};

		$scope.getSaveData = function() {
			return {
				submission_date: $filter('date')($scope.subject.submission_date, 'yyyy-MM-dd'),
				message: $scope.subject.message,
				attachment: $scope.subject.attachment.map(({id, file_id}) => ({id, file_id})),
			};
		};
	}

	
	publishSubject(data){
		this.$scope.basicHttpConfigProcess({
			url: this.jsDataService.get('sendSignUrl'),
			method: 'POST',
			data: {
//				id: data.id,
//				subject: data.subject,
				submission_date: data.submission_date,
				message: data.message,
				attachment: data.attachment.map(({id, file_id}) => ({id, file_id})),
			}
		}).then((response) => {
			if(response.data.success){

			}
		}, () => {});
	}


	openAskToSignDialog(ev){
		const subject = new communicationSubjectModel({
			message: '',
			attachment: [],
			object_number: this.objectNumber,
		});


		this.$mdDialog.show({
			controller: ['$scope', '$mdDialog', 'jsDataService', 'subject', this.AskToSignEditorCtrl],
			controllerAs: 'ctrl',
			templateUrl: 'contracts/ask_for_sign_editor.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: false,
			fullscreen: true,
			locals: {
				subject: subject,
			}
		}).then((results) => {
			this.publishAskToSignSubject(results);
		}, (results) => {
			console.log(results);
		});
	}

	AskToSignEditorCtrl($scope, $mdDialog, jsDataService, subject){
		$scope.subject = angular.copy(subject);
		$scope.subjectForm;
		$scope.uploadUrl = jsDataService.get('cfgUploadUrl');
		$scope.close = function() {
			$mdDialog.cancel();
		};

		$scope.save = function() {
			if(!this.isValid()) {
				return;
			}
			$mdDialog.hide($scope.subject);
		};

		$scope.fileAdded = function ($file) {
			const file = {
				id: '0',
				file_id: '0',
				name: $file.name,
				isFlow: true,
				flowFile: $file,
			};

			$scope.subject.attachment.push(file);
			return true;
		};

		$scope.fileSubmitted = function() {
			$scope.subject.flow.upload();
		};

		$scope.fileUploaded = function ($file, $message) {
			const file = $scope.subject.attachment.find(f => f.flowFile?.uniqueIdentifier === $file.uniqueIdentifier);

			if(!file) {
				return;
			}

			try {
				const response = JSON.parse($message);
				file.file_id = response.fileId;
				$scope.subjectForm['attachment'].$setViewValue(Date.now());
			} catch(err) {

			}
		};

		$scope.removeFile = function (file) {
			$scope.subject.attachment = $scope.subject.attachment.filter(f => f !== file);
			$scope.subjectForm['attachment'].$setViewValue(Date.now());
		};

		$scope.isValid = function (){
			return !$scope.subject.flow.isUploading();
		};

		$scope.getSaveData = function() {
			return {
				message: $scope.subject.message,
				attachment: $scope.subject.attachment.map(({id, file_id}) => ({id, file_id})),
			};
		};
	}


	publishAskToSignSubject(data){
		this.$scope.basicHttpConfigProcess({
			url: this.jsDataService.get('askToSignUrl'),
			method: 'POST',
			data: {
				message: data.message,
				attachment: data.attachment.map(({id, file_id}) => ({id, file_id})),
			}
		}).then((response) => {
			if(response.data.success){

			}
		}, () => {});
	}


	signRefuseModal(ev){
		const subject = new communicationSubjectModel({
			message: ''
		});
		this.$mdDialog.show({
			controller: ['$scope', '$mdDialog', 'jsDataService', 'subject', this.SignReturnRefuseEditorCtrl],
			controllerAs: 'ctrl',
			templateUrl: 'contracts/sign_refuse_editor.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: false,
			fullscreen: true,
			locals: {
				subject: subject,
			}
		}).then((results) => {
			this.$scope.basicHttpConfigProcess({
				url: this.signRefuseUrl,
				method: 'POST',
				data: {
					message: results.message
				}
			}).then((response) => {
				if(response.data.success){

				}
			}, () => {});
		}, (results) => {
			console.log(results);
		});
	}
	
	signReturnModal(ev){
		const subject = new communicationSubjectModel({
			message: ''
		});
		this.$mdDialog.show({
			controller: ['$scope', '$mdDialog', 'jsDataService', 'subject', this.SignReturnRefuseEditorCtrl],
			controllerAs: 'ctrl',
			templateUrl: 'contracts/sign_return_editor.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose: false,
			fullscreen: true,
			locals: {
				subject: subject,
			}
		}).then((results) => {
			this.$scope.basicHttpConfigProcess({
				url: this.signReturnUrl,
				method: 'POST',
				data: {
					message: results.message
				}
			}).then((response) => {
				if(response.data.success){

				}
			}, () => {});
		}, (results) => {
			console.log(results);
		});
	}


	SignReturnRefuseEditorCtrl($scope, $mdDialog, jsDataService, subject){
		$scope.subject = angular.copy(subject);
		$scope.subjectForm;
		$scope.close = function() {
			$mdDialog.cancel();
		};

		$scope.save = function() {
			$mdDialog.hide($scope.subject);
		};
	}

	contractSignModal(ev){
		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", "jsDataService", this.signModalCtrl],
			templateUrl: 'contracts/sign_modal.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose:false,
			fullscreen: true,
			locals: {

			}
		}).then((results) => {
			if(typeof(results.signUrl) !== 'undefined'){
				this.$scope.$root.basicHttpConfigProcess({
					url: results.signUrl,
					method: 'POST',
					responseType: 'json',
					data: {
						code: results.code
					}
				});
			}
		}, () => {});

	}

	signModalCtrl($scope, $mdDialog, jsDataService){
		$scope.code = '';
		$scope.enterCode = false;
		$scope.signUrl = '';

		$scope.save = function() {
			$mdDialog.hide({
				signUrl:$scope.signUrl,
				code:$scope.code
			});
		};

		$scope.getCode = function() {
			if(typeof(jsDataService.get('signCodeUrl')) !== 'undefined' && jsDataService.get('signCodeUrl') !== ''){
				$scope.$root.basicHttpConfigProcess({
					url: jsDataService.get('signCodeUrl'),
					method: 'GET'
				}).then((response) => {
					if(response.data.success){
						$scope.enterCode = true;
						$scope.signUrl = response.data.signUrl;
					}
				}, () => {});
			}
		};
		$scope.close = function() {
			$mdDialog.cancel();
		};
	}
	
	setApplicantSections(ev){
		this.$mdDialog.show({
			controller: ["$scope", "$mdDialog", "$filter", "jsDataService", "item", this.applicanteditDialogCtrl],
			templateUrl: 'contracts/contract_applicantedit.html',
			parent: angular.element(document.body),
			targetEvent: ev,
			clickOutsideToClose:false,
			fullscreen: true,
			locals: {
				item: this.item
			}
		}).then((results) => {
			this.$scope.$root.basicHttpConfigProcess({
				url: this.item.applicant_url,
				method: 'POST',
				responseType: 'json',
				data: results
			});
		}, () => {});
	}
	
	applicanteditDialogCtrl($scope, $mdDialog, $filter, jsDataService, item){
		$scope.editSections = angular.copy(item.edit_sections);
		$scope.message = '';
		$scope.submission_date = '';
		$scope.close = function() {
			$mdDialog.cancel();
		};
		$scope.save = function() {
			let outp = {
				edit_sections: {},
				message: $scope.message,
				date: $filter('date')($scope.submission_date, 'yyyy-MM-dd'),
			};
			for(let k in $scope.editSections){
				outp.edit_sections[k] = $scope.editSections[k];
			}
			$mdDialog.hide(outp);
		};
	}
	
//	applicantComplete(ev){
//		const confirmTexts = this.jsDataService.get('applicantcompleteConfirmTexts');
//		const confirm = this.$mdDialog.confirm()
//			.title(confirmTexts.title)
//			.htmlContent(confirmTexts.content)
//			.ariaLabel(confirmTexts.title)
//			.targetEvent(ev)
//			.ok(confirmTexts.ok)
//			.cancel(confirmTexts.cancel);
//		this.$mdDialog.show(confirm).then(() => {
//			this.$scope.$root.basicHttpConfigProcess({
//				url: this.item.applicant_complete_url,
//				method: 'GET',
//				responseType: 'json'
//			});
//		}, () => {});
//	}
	
	
	applicantValidateComplete(ev){
		if(this.item.status == 1){
			this.$mdDialog.show({
				controller: ["$scope", "$mdDialog", "item", this.validateCompleteDialogCtrl],
				templateUrl: 'contracts/applicant_complete.html',
				parent: angular.element(document.body),
				targetEvent: ev,
				clickOutsideToClose:false,
				fullscreen: true,
				locals: {
					item: this.item
				}
			}).then((results) => {
				console.log('dialog close', results);
			}, () => {});
		}
	}
	
	validateCompleteDialogCtrl($scope, $mdDialog, item){
		/**
		 * 0 - klaida kai nera galiybes siusti
		 * 1 - pranesimas kas bus daroma
		 * 2 - loaderis kad vyksta
		 * 3 - atsakymas su klaidomis
		 *
		 * 5 - pranesimas apie sekminga submitinima ir mygtukas uzdaryti 
		 *  - esant klaidai, klaida parodoma klaidu vietoje o dialogas uzdaromas
		 */
		$scope.state = 0;
		$scope.reloadOnClose = false;
		
		$scope.item = item;
		
		if(typeof($scope.item.applicant_validate_url) !== 'undefined' && $scope.item.applicant_validate_url !== ''){
			$scope.state = 1;
		}
		
		$scope.responseData;
		
		$scope.startValidate = function(){
			if($scope.state > 0){
				$scope.state = 2;
				$scope.$root.basicHttpConfigProcess({
					url: $scope.item.applicant_validate_url,
					method: 'GET',
					responseType: 'json',
				}).then((results) => {
					if(typeof(results.data.close) !== 'undefined'){
						$scope.close();
					}
					else{
						if(!results.data.success){
							$scope.state = 3;
							$scope.responseData = Object.values(results.data.errordata);
						}
						else{
							$scope.state = 5;
						}
					}
				});
			}
		};
		
//		$scope.startSubmit = function(){
//			if($scope.state > 0){
//				$scope.state = 2;
//				$scope.$root.basicHttpConfigProcess({
//					url: $scope.item.applicant_complete_url,
//					method: 'GET',
//					responseType: 'json',
//				}).then((results) => {
//					if(typeof(results.data.close) !== 'undefined'){
//						$scope.close();
//					}
//					else{
//						if(results.data.success){
//							$scope.state = 5;
//							$scope.reloadOnClose = true;
//							$scope.responseData = results.data.inform;
//						}
//						else{
//							$scope.close();
//						}
//					}
//				});
//			}
//		};
//		
		
		
		$scope.getSectionFormatedTitle = function(section){
			let nr = '';
			if(section.numbered == 1 && section.number !== ''){
				nr = section.number + ' ';
			}
			return nr + section.title;
		};
		
		$scope.close = function() {
			if($scope.reloadOnClose){
				window.location.reload(true);
			}
			$mdDialog.cancel();
		};
	}
	
	
}